import Application from '@/models/Application';

const GET_APPLICATIONS = 'get_applications';
const GET_APPLICATIONS_REQUEST = 'get_applications_request';
const GET_APPLICATIONS_SUCCESS = 'get_applications_success';
const GET_APPLICATIONS_ERROR = 'get_applications_error';

export { GET_APPLICATIONS };

export default {
    state: {
        applications: [],
        loading: false,
        applicationsErrors: [],
        applicationsMeta: []
    },
    mutations: {
        [GET_APPLICATIONS_REQUEST]: (state) => {
            state.applications = [];
            state.loading = true;
            state.applicationsErrors = [];
            state.applicationsMeta = {};
        },
        [GET_APPLICATIONS_SUCCESS]: (state, { applications, meta }) => {
            state.applications = applications;
            state.loading = false;
            state.applicationsErrors = [];
            state.applicationsMeta = meta;
        },
        [GET_APPLICATIONS_ERROR]: (state, { errors }) => {
            state.applications = [];
            state.loading = false;
            state.applicationsErrors = errors;
            state.applicationsMeta = {};
        },
    },
    actions: {
        [GET_APPLICATIONS]: ({ commit, state, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_APPLICATIONS_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.applicationsMeta.current_page) {
                        params.page = state.applicationsMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                const TrajectoryApplications = Application.makeModel(`/trajectories/${trajectoryId}/applications`);
                TrajectoryApplications.collection(params)
                    .then(({ items, meta }) => {
                        commit(GET_APPLICATIONS_SUCCESS, { applications: items, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_APPLICATIONS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/applications.js